<app-app-layout>
  <div class="biometric-container">
    <div class="row">
      <div class="col-12">
        <app-user-info-card
          [email]="subscriberDetail.email"
          [name]="subscriberDetail.name"
        >
        </app-user-info-card>
      </div>
    </div>

    <app-gym-branch-selection-card
      [selectedBranchId]="selectedBranchId"
      (branchSelected)="onBranchSelected($event)"
      (subscriptionExpiryDate)="onSubscriptionExpiryDate($event)"
    ></app-gym-branch-selection-card>

    <div class="biometric-card">
      <mat-card>
        <div style="margin: 16px 0; text-align: center">
          <h5 style="margin: 0; font-weight: 600">Purchase Biometric Access</h5>
          <p style="margin: 4px 0; color: #666">
            Pro-rated pricing at
            <strong>₹{{ 100 * perMemberPerDay | number : "1.2-2" }}</strong> per
            day for 100 members
          </p>
        </div>

        <mat-card-content>
          <!-- Warning if subscription expiry is missing -->
          <div
            *ngIf="!subscriptionExpiryDate && !isLoading"
            class="warning-message"
            style="
              margin-bottom: 16px;
              padding: 12px;
              background: #fff3cd;
              border-radius: 8px;
              border-left: 4px solid #ffc107;
              color: #856404;
            "
          >
            <mat-icon style="vertical-align: middle; margin-right: 8px"
              >warning</mat-icon
            >
            <span
              >Subscription expiry date is not available. Please ensure your
              subscription is active.</span
            >
          </div>

          <div
            *ngIf="subscriptionExpiryDate"
            class="expiry-display"
            style="
              margin-bottom: 16px;
              padding: 12px;
              background: #f5f5f5;
              border-radius: 8px;
            "
          >
            <div
              style="
                margin: 4px 0;
                color: #666;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                gap: 8px;
              "
              class="expiry-info-row"
            >
              <div>
                <strong>Subscription Expires:</strong>
                {{ subscriptionExpiryDate | date : "dd MMM yyyy" }}
              </div>
              <div *ngIf="daysRemaining > 0">
                <strong>Days Remaining:</strong> {{ daysRemaining }} days
              </div>
            </div>
          </div>

          <div class="form-row">
            <mat-form-field
              appearance="outline"
              style="width: 100%; margin-bottom: 10px"
            >
              <mat-label>Number of members you are purchasing</mat-label>
              <mat-select
                [(ngModel)]="memberCount"
                [formControl]="billingForm.get('memberCount')"
              >
                <mat-option *ngFor="let count of memberOptions" [value]="count">
                  {{ count }} Members
                </mat-option>
              </mat-select>
              <mat-error
                >Please select the number of members you are
                purchasing</mat-error
              >
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Billing Information Card -->
    <div class="billing-card">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Billing Information</mat-card-title>
          <mat-card-subtitle
            >Required for invoice generation and tax
            compliance</mat-card-subtitle
          >
        </mat-card-header>

        <mat-card-content>
          <!-- Validation Error Message -->
          <div *ngIf="showValidationError" class="validation-error-message">
            <mat-icon>error</mat-icon>
            <div class="error-content">
              <span class="error-title"
                >Please complete all required fields</span
              >
              <span class="error-subtitle"
                >Check the highlighted fields below and fill in the missing
                information</span
              >
            </div>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Country</mat-label>
              <input
                type="text"
                matInput
                [matAutocomplete]="autoCountry"
                [formControl]="billingForm.get('country')"
                (input)="onCountryInput($event)"
                placeholder="Search country..."
              />
              <mat-autocomplete
                #autoCountry="matAutocomplete"
                [displayWith]="getCountryDisplayValue"
                (optionSelected)="onCountrySelected($event.option.value)"
              >
                <mat-option *ngFor="let c of filteredCountries" [value]="c">{{
                  c.label
                }}</mat-option>
              </mat-autocomplete>
              <mat-error>Please select your country</mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>State</mat-label>
              <input
                type="text"
                matInput
                [matAutocomplete]="autoState"
                [formControl]="billingForm.get('state')"
                (input)="onStateInput($event)"
                placeholder="Search state..."
              />
              <mat-autocomplete
                #autoState="matAutocomplete"
                [displayWith]="getStateDisplayValue"
                (optionSelected)="onStateSelected($event.option.value)"
              >
                <mat-option *ngFor="let s of filteredStates" [value]="s">{{
                  s.state
                }}</mat-option>
              </mat-autocomplete>
              <mat-error>Please select your state</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
              <mat-label>District</mat-label>
              <input
                type="text"
                matInput
                [matAutocomplete]="autoDistrict"
                [formControl]="billingForm.get('district')"
                (input)="onDistrictInput($event)"
                placeholder="Search district..."
              />
              <mat-autocomplete
                #autoDistrict="matAutocomplete"
                (optionSelected)="onDistrictSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let d of filteredDistricts; trackBy: trackByDistrict"
                  [value]="d"
                  >{{ d }}</mat-option
                >
              </mat-autocomplete>
              <mat-error>Please select your district</mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>PIN Code</mat-label>
              <input
                matInput
                type="text"
                maxlength="6"
                pattern="[0-9]*"
                inputmode="numeric"
                [formControl]="billingForm.get('pinCode')"
                placeholder="Enter 6-digit PIN"
              />
              <mat-error>Please enter a valid 6-digit PIN code</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Gym Name</mat-label>
              <input
                matInput
                type="text"
                [formControl]="billingForm.get('gymName')"
                placeholder="Optional"
              />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Address</mat-label>
              <textarea
                matInput
                rows="2"
                [formControl]="billingForm.get('addressLine')"
                placeholder="Street address, building, area"
                required
              ></textarea>
              <mat-error>Please enter your complete address</mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-label
              style="margin-bottom: 8px; display: block; font-weight: 500"
              >Are you registered for GST?</mat-label
            >
            <mat-radio-group
              [formControl]="billingForm.get('hasGST')"
              class="inline-radios"
            >
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="form-row" *ngIf="billingForm.get('hasGST')?.value">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>GST Number</mat-label>
              <input
                matInput
                type="text"
                [formControl]="billingForm.get('gstNumber')"
              />
              <mat-hint>Format: 22AAAAA0000A1Z5 (15 characters)</mat-hint>
              <mat-error
                *ngIf="billingForm.get('gstNumber')?.hasError('required')"
                >GST number is required for registered businesses</mat-error
              >
              <mat-error
                *ngIf="billingForm.get('gstNumber')?.hasError('pattern')"
                >Please enter a valid GST number</mat-error
              >
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Review & Pay Card -->
    <div
      class="review-card"
      *ngIf="isGstFeatureEnabled && daysRemaining > 0 && memberCount > 0"
    >
      <mat-card>
        <mat-card-header>
          <mat-card-title>Order Summary</mat-card-title>
          <mat-card-subtitle
            >Review your purchase details before payment</mat-card-subtitle
          >
        </mat-card-header>

        <mat-card-content>
          <div class="amount-row">
            <span>Base Amount:</span>
            <span>₹{{ getBaseAmount() }}</span>
          </div>
          <div class="amount-row">
            <span>GST (18%):</span>
            <span>₹{{ getGstAmount() }}</span>
          </div>
          <div class="amount-total">
            <span>Total Amount:</span>
            <span>₹{{ getTotalAmountWithGst() }}</span>
          </div>
          <div
            *ngIf="subscriptionExpiryDate"
            class="expiry-info"
            style="
              margin-top: 12px;
              padding-top: 12px;
              border-top: 1px solid #eee;
              font-size: 13px;
              color: #666;
            "
          >
            <p style="margin: 4px 0">
              <strong>Expires on:</strong>
              {{ subscriptionExpiryDate | date : "dd MMM yyyy" }}
            </p>
            <p style="margin: 4px 0">
              <strong>Members Purchasing:</strong> {{ memberCount }}
            </p>
          </div>
        </mat-card-content>

        <mat-card-actions>
          <button
            mat-raised-button
            color="primary"
            class="pay-now-button"
            (click)="payNow()"
            [disabled]="
              billingForm.invalid ||
              !subscriptionExpiryDate ||
              daysRemaining <= 0 ||
              isLoading
            "
          >
            <span *ngIf="isLoading">Processing...</span>
            <span *ngIf="!isLoading"
              >Proceed to Pay ₹{{ getTotalAmountWithGst() }}</span
            >
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</app-app-layout>
